import {
  Target,
  Sparkles,
  Users2,
  MessageCircle,
  Map,
  User,
  Crown,
  Users,
  ShieldCheck,
} from "lucide-react";

const FEATURES = [
  {
    icon: Users2,
    title: "Trip-Based Matching",
    text: "Find travelers visiting the same destination on similar dates.",
    tint: "bg-[#F4EBFC] text-[#7209B7]",
  },
  {
    icon: Sparkles,
    title: "AI Trip Assistant",
    text: "Get travel ideas, destination suggestions, and itinerary recommendations.",
    tint: "bg-[#EFF6FF] text-[#3B82F6]",
  },
  {
    icon: MessageCircle,
    title: "Trip Requests & Chat",
    text: "Connect and communicate before your journey.",
    tint: "bg-[#E0F2FE] text-[#0284C7]",
  },
  {
    icon: Map,
    title: "Trip Suggestions",
    text: "Explore hundreds of destinations and plan your next adventure.",
    tint: "bg-[#FDF2F8] text-[#EC4899]",
  },
  {
    icon: User,
    title: "Co-Traveler Selection",
    text: "Choose your preferred travel companion after getting to know each other.",
    tint: "bg-[#ECFDF5] text-[#059669]",
  },
  {
    icon: Crown,
    title: "Premium Features",
    text: "Unlock Instant Connect, Nearby Matches, Boosts, and more.",
    tint: "bg-[#FEF3C7] text-[#D97706]",
  },
  {
    icon: Users,
    title: "Travel Community",
    text: "Share travel stories, photos, and experiences with fellow travelers.",
    tint: "bg-[#FFF7ED] text-[#EA580C]",
  },
  {
    icon: ShieldCheck,
    title: "Safety Features",
    text: "Real-time selfie verification, Safe Mode, Trusted Contacts, reporting tools, and SOS assistance help create a more trusted travel environment.",
    tint: "bg-[#F0FDFA] text-[#0D9488]",
  },
];

export default function MissionOffer() {
  return (
    <section className="mx-auto max-w-7xl px-5 py-4 sm:px-8 sm:py-6">
      <div className="grid gap-6 lg:grid-cols-[1fr_1.6fr]">
        {/* Our Mission */}
        <div className="flex flex-col overflow-hidden rounded-[32px] bg-[#F4EBFC] shadow-[0_4px_20px_rgba(0,0,0,0.02)] border border-violet-100/30">
          <div className="p-6 sm:p-8 pb-4">
            <div className="mb-4 flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-violet-200/70">
                <Target className="h-5 w-5 text-[#7209B7]" strokeWidth={2} />
              </div>
              <h3 className="font-display text-xl font-bold text-slate-900 sm:text-2xl">
                Our Mission
              </h3>
            </div>
            <p className="mt-1 text-sm ">
              Our mission is to make solo travel safer, more social, and more
              enjoyable by helping travelers build meaningful travel
              connections around the world.
            </p>
            <hr className="my-4 border-t border-violet-200/100" />
            <p className="text-sm  ">
              We aim to create a trusted community where people can discover
              fellow travelers, share experiences, and create unforgettable
              memories together.
            </p>
          </div>

          <img
            src="/img/about-us/Our-Mission.svg"
            alt="Three hikers walking together on a mountain trail"
            className="mt-auto w-full object-cover max-h-[220px] lg:max-h-[none]"
          />
        </div>

        {/* What We Offer */}
        <div className="rounded-[32px] border border-slate-100 bg-white p-6 sm:p-8 shadow-[0_4px_20px_rgba(0,0,0,0.02)]">
          <h3 className="font-display text-xl font-bold text-slate-900 sm:text-2xl">
            What We Offer
          </h3>
          <p className="mt-2 text-sm text-slate-600 ">
            SoloConnect provides everything you need to connect with fellow
            travelers before your journey begins:
          </p>

          <div className="mt-6 grid gap-x-6 gap-y-5 sm:grid-cols-2">
            {FEATURES.map(({ icon: Icon, title, text, tint }) => (
              <div key={title} className="flex gap-4">
                <div
                  className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${tint}`}
                >
                  <Icon className="h-5 w-5" strokeWidth={2} />
                </div>
                <div>
                  <p className="text-base font-bold text-slate-900 ">{title}</p>
                  <p className="mt-0.5 text-sm  text-slate-500 ">
                    {text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

